/* eslint-disabled */

export default class DemandeAttestationExtend {


  constructor (object?: any) {
  }

  postConstruct () {
  }
}
